// ** React Imports
import React, {Fragment, useEffect, useState} from 'react'

import Select from "react-select";
import axios from "axios";
import {Label} from "reactstrap";

const RoleList = ({ onRoleChange, value }) => {

    const [role, setRole] = useState(null);
    const [roleList, setRoleList] = useState([]);

    const handleRole = e => {
        setRole(e);
        onRoleChange(e);
    }

    const getRoles = async () => {
        const rolesUrl = `${process.env.REACT_APP_API_URL}/roles`;
        const response = await axios.get(rolesUrl);
        let rolesListData = response?.data.data;

        rolesListData = rolesListData.map(role => {
            return {
                value: role.id,
                label: role.name
            }
        })

        localStorage.setItem('roles', JSON.stringify(rolesListData));
        setRoleList(rolesListData);
        if (value) {
            const item = rolesListData.find(role => role.label === value);
            if (item) {
                setRole(item);
            } else {
                setRole(value);
            }
        }
    }

    useEffect(() => {
        getRoles();
    }, []);

    return (
        <Fragment>
            <Label className='me-1' for='search-input'>
                Rol *
            </Label>

            <span style={{width: '250px'}}>
                        <Select
                            className='dataTable-filter mb-50'
                            classNamePrefix='select'
                            options={roleList}
                            value={role}
                            onChange={handleRole}
                        />
                            </span>
        </Fragment>
    )
}

export default RoleList;